import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../utils/generalUtil";
import { useSubscriptionExpired } from "../hooks/useSubscriptionExpired";
import SubscriptionExpiredModal from "../Components/subscription/SubscriptionExpiredModal";
import LoadingSpinner from "../Components/loadingSpinner/LoadingSpinner";

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const [isAuth, setIsAuth] = useState<boolean | null>(null);
  const [authLoading, setAuthLoading] = useState(true);

  const {
    isExpired,
    subscriptionInfo,
    loading: subscriptionLoading,
  } = useSubscriptionExpired();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const authenticated = isAuthenticated();
        setIsAuth(authenticated);
      } catch (error) {
        console.error("Erro ao verificar autenticação:", error);
        setIsAuth(false);
      } finally {
        setAuthLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (authLoading || subscriptionLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <LoadingSpinner />
      </div>
    );
  }

  if (isAuth === false) {
    return <Navigate to="/login" replace />;
  }

  if (isExpired && subscriptionInfo && subscriptionInfo.subscription) {
    return (
      <>
        {children}
        <SubscriptionExpiredModal
          open={true}
          subscriptionInfo={subscriptionInfo}
          onClose={() => {}}
        />
      </>
    );
  }

  return children;
};

export default ProtectedRoute;
